import React from "react";
import { Form, Button, InputGroup, Image } from "react-bootstrap";
import { isEmpty } from "lodash";
import { Formik, Field } from "formik";
import {
  SearchableList,
  FieldDropSide,
  FormControlSearch,
} from "../../../../components";
import {
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
} from "../../../../utils";
import { getInvestmentType } from "../../../../services";
import { useRequest } from "../../../../abstracts";

const initialValues = {
  investmentType: null,
  investmentStatus: null,
};

const all = { label: "All", value: null };

const MasterInvestmentFilter = ({ fields, filteredValues, onFormSubmit }) => {
  const { response: investmentTypes, loading } = useRequest({
    method: getInvestmentType,
    defaultResponse: [],
  });

  return (
    <Formik
      initialValues={{
        ...initialValues,
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        setFieldError,
        handleSubmit,
        setValues,
        values,
        ...rest
      }) => {
        return (
          <Form
            autoComplete="off"
            className="mb-20 mt-10"
            onSubmit={handleSubmit}
            validated={!isEmpty(rest.errors)}
          >
            <div className="d-flex align-item-center pad-50-right">
              <div className="search-bar-plan mt-16">
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text className="plan-search-button">
                      <Image src="/assets/icons/svg/search.svg" width="14px" />
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <FormControlSearch
                    type="search"
                    placeholder="Search investment name, ticker, CUSIP"
                    onChange={(e) => {
                      setFieldValue(fields.search, e.target.value);
                    }}
                  />
                </InputGroup>
              </div>
              <div className="d-flex ml-3">
                <Field
                  size="smd"
                  isRequired
                  name={fields.investmentType}
                  label={"Investment Type"}
                  value={values[fields.investmentType]}
                  options={[
                    all,
                    ...investmentTypes.map((type, index) => ({
                      label: type.name,
                      value: parseInt(type.id),
                    })),
                  ]}
                  popupContent={
                    <SearchableList
                      label="Select an Investment Type"
                      isRadio
                      selectedValue={values[fields.investmentType]}
                      options={[
                        all,
                        ...investmentTypes.map((type, index) => ({
                          label: type.name,
                          value: parseInt(type.id),
                        })),
                      ]}
                      onSelect={(value) =>
                        setFieldValue(fields.investmentType, value)
                      }
                    />
                  }
                  component={FieldDropSide}
                />
              </div>
              <div className="d-flex ml-3">
                <Field
                  name={fields.investmentStatus}
                  isRequired
                  size="smd"
                  label="Investment Status"
                  value={values[fields.investmentStatus]}
                  options={[
                    all,
                    ...toOptionValuesFromMapper(
                      OPTIONS_DATA_MAPPER.INVESTMENT_STATUS_MASTER
                    ),
                  ]}
                  popupContent={
                    <SearchableList
                      label="Select an investment status"
                      options={[
                        all,
                        ...toOptionValuesFromMapper(
                          OPTIONS_DATA_MAPPER.INVESTMENT_STATUS_MASTER
                        ),
                      ]}
                      onSelect={(value) =>
                        setFieldValue(fields.investmentStatus, value)
                      }
                    />
                  }
                  component={FieldDropSide}
                />
              </div>
              <Button
                className="ml-3 mt-12 sort-button"
                style={{ lineHeight: "19px" }}
                variant="secondary"
                type="submit"
              >
                Search
              </Button>
            </div>
            <div className="d-flex justify-content-end">
              <p className="investment-count font-weight-500">
                {!isEmpty(filteredValues)
                  ? filteredValues.length > 1
                    ? `${filteredValues.length} investments found`
                    : `${filteredValues.length} investment found`
                  : `0 investments found`}
              </p>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default MasterInvestmentFilter;
